<template>
  <v-main>
    <v-card
      class="ma-2"
      flat
    >
      <v-row>
        <v-col cols="12" md="8">
          <v-card-title v-if="warehouseId">Изменить склад</v-card-title>
          <v-card-title v-else>Создать склад</v-card-title>
        </v-col>
      </v-row>
      <WarehouseForm/>
    </v-card>
  </v-main>
</template>

<script>

import WarehouseForm from "@/views/warehouses/WarehouseForm.vue";

export default {
  components: {WarehouseForm},
  computed: {
    warehouseId() {
      return this.$route.params.id;
    },
  },
};
</script>
